import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { removeQueryAndHash } from '../../utils/urls/urlGenerator';

import LazyImage from './LazyImage';

// Master list of what "version_id"s are for can be found here:
// https://github.com/paperlesspost/paperless-post/blob/master/config/data/media_file_versions.yml
//
// A Selection of results from using version_ids on a "tall" card...
// version_id
// 1: 454 x 636 PNG 350 KB
// 2: 454 x 636 PNG 341 KB
// 3: 107 x 150 PNG 31 KB
// 4: 454 x 636 PNG 350 KB
// 5: 454 x 636 PNG 350 KB
//
// 6: 107 x 150 JPG 6.9 KB     Photo, thumb
// 7: 233 x 327 JPG 23.5 KB    Photo, small
// 8: 454 x 636 JPG 70.4 KB    Photo, medium
// 9: 454 x 636 JPG 70.4 KB
// 10: 454 x 636 PNG 350 KB

const getImageVersion = (size, shape, isMobile) => {
  switch (shape) {
    case 'novelty':
      // Note: "novelty" does not have large, PNG images with a baked-in dropshadow
      switch (size) {
        case 'thumb':
          return 3;
        case 'small':
        case 'medium':
        default:
          return 4;
      }
    case 'tall':
    case 'horizontal':
    case 'wide':
    case 'square':
    default:
      switch (size) {
        case 'thumb':
          return 6;
        case 'small':
          return 7;
        case 'medium':
        default:
          return isMobile ? 7 : 8;
      }
  }
};

const AssetImage = props => {
  const { className, alt = 'alt', src, shape, size, isMobile } = props;
  const imageURL = `${removeQueryAndHash(src)}?version_id=${getImageVersion(
    size,
    shape,
    isMobile,
  )}`;

  return <LazyImage className={className} alt={alt} src={imageURL} />;
};

AssetImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  shape: PropTypes.oneOf(['tall', 'square', 'horizontal', 'wide', 'novelty'])
    .isRequired,
  size: PropTypes.oneOf(['small', 'thumb', 'full']),
  isMobile: PropTypes.bool,
};

const mapStateToProps = ({ env: { isMobile } }) => ({ isMobile });

export default connect(mapStateToProps)(AssetImage);
